import React from 'react';
import { logErrorToAnalytics } from '../../utils/logError'; // Import the error logging function

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }; // Update state so the next render shows fallback UI
  }

  componentDidCatch(error, errorInfo) {
    const chunkLoadError =
      error?.name === "ChunkLoadError" ||
      /Loading chunk [\w-]+ failed/i.test(error?.message || "");

    if (chunkLoadError && typeof window !== "undefined") {
      const reloadKey = "autowiz_chunk_reload_attempted";

      if (!window.sessionStorage.getItem(reloadKey)) {
        window.sessionStorage.setItem(reloadKey, "true");
        window.location.reload();
        return;
      }
    }

    // Log the error to Firebase Analytics
    logErrorToAnalytics(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1 className='error-message-from-error-boundary'>Something went wrong. Please try to reload the page or re-login into your account.</h1>; // Custom fallback UI
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
